import React from 'react';

export const VehicleIcon = ({ size = 28 }) => (
  <svg height={size} viewBox="0 0 28 28" width={size} xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-75 -408)">
      <g fill="none" stroke="#0a3256" strokeWidth="2">
        <circle cx="89" cy="422" r="14" stroke="none" />
        <circle cx="89" cy="422" fill="none" r="13" />
      </g>
      <g fill="#fff" stroke="#0a3256" strokeWidth="1.5">
        <circle cx="89" cy="422" r="8.25" stroke="none" />
        <circle cx="89" cy="422" fill="none" r="7.5" />
      </g>
      <g fill="#fff" stroke="#0a3256">
        <circle cx="89" cy="422" r="3.75" stroke="none" />
        <circle cx="89" cy="422" fill="none" r="3.25" />
      </g>
      <g fill="#0a3256" transform="translate(87.75 420.75)">
        <path d="m1.25 2.25c-.55140001 0-1-.44860005-1-1 0-.55140001.44859999-1 1-1 .55139995 0 1 .44859999 1 1 0 .55139995-.44860005 1-1 1z" />
        <path
          d="m1.25.5c-.41355002 0-.75.33644998-.75.75s.33644998.75.75.75.75-.33644998.75-.75-.33644998-.75-.75-.75m0-.5c.69036007 0 1.25.55964005 1.25 1.25 0 .69036007-.55963993 1.25-1.25 1.25-.69035995 0-1.25-.55963993-1.25-1.25 0-.69035995.55964005-1.25 1.25-1.25z"
          fill="#0a3256"
        />
      </g>
      <g fill="none">
        <path d="m755 5192.545v-3.171" stroke="#0a3256" strokeLinecap="round" transform="translate(-666 -4774.295)" />
        <path
          d="m755 5192.773v-3.4"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(0 1 -1 0 5285.074 -333)"
        />
        <path
          d="m755 5192.512v-3.138"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(0 1 -1 0 5274.625 -333)"
        />
        <path
          d="m755 5192.659v-3.284"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(-.70710678 .70710678 -.70710678 -.70710678 4297.219 3562.488)"
        />
        <path
          d="m755 5192.31v-2.936"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(-.70710678 .70710678 -.70710678 -.70710678 4289.595 3554.864)"
        />
        <path
          d="m755 5192.386v-3.011"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(.629 .777 -.777 .629 3651.817 -3435.008)"
        />
        <path
          d="m755 5192.863v-3.488"
          stroke="#0a3256"
          strokeLinecap="round"
          transform="matrix(.629 .777 -.777 .629 3644.176 -3427.812)"
        />
        <path
          d="m757.622 5187.509a13.394 13.394 0 0 1 3.757 3.352 12.328 12.328 0 0 1 1.771 4.576"
          stroke="#0a3256"
          strokeLinecap="round"
          strokeWidth="1.2"
          transform="translate(-663.738 -4774.261)"
        />
        <path d="m755 5192.545v-3.171" stroke="#0a3256" strokeLinecap="round" transform="translate(-666 -4763.624)" />
        <path
          d="m757.622 5187.509a13.394 13.394 0 0 1 3.757 3.352 12.328 12.328 0 0 1 1.771 4.576"
          stroke="#0a3256"
          strokeLinecap="round"
          strokeWidth="1.2"
          transform="matrix(-.99862953 .05233596 -.05233596 -.99862953 1113.044 5572.313)"
        />
      </g>
    </g>
  </svg>
);
